import { HasUnsavedChangesComponent } from '@ami/angular/core/auth';
import {
  Component,
  ElementRef,
  Injector,
  OnDestroy,
  effect,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import * as ReactDOM from 'react-dom';

@Component({
    template: ''
  })
  export abstract class ReactWrapperComponent implements OnDestroy, HasUnsavedChangesComponent {
    containerRef = inject(ElementRef).nativeElement;
    route = inject(ActivatedRoute);
    private injector = inject(Injector);
  
    private url = toSignal(this.route.url);
  
    constructor() {
      effect(() => {
        if (this.url()) this.rerender();
      });
    }
  
    private unsavedChanges: boolean = false;
  
    public hasUnsavedChanges() : boolean {
      return this.unsavedChanges;
    }
  
    ngOnDestroy() {
      this.unload();
    }
  
    private unload() {
      ReactDOM.unmountComponentAtNode(this.containerRef);
    }
  
    private render() {
      ReactDOM.render(this.getElement((x) => this.onHasUnsavedChangesChanged(x), this.injector), this.containerRef);
    }
  
    protected abstract getElement(onHasUnsavedChangesChangedFn :(x:boolean) => void, injector:Injector ): JSX.Element;
  
    private onHasUnsavedChangesChanged(saved:boolean|undefined) {
      this.unsavedChanges = saved === true;
    }
  
    private rerender() {
      this.unload();
      this.unsavedChanges = false;
      this.render();
    }
  }